import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useUpdateOperationMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { parseOperationEntity } from 'api/helpers/operation';
import { parseUpdateOperationParams } from 'api/helpers/operation/parseUpdateOperationParams';
import { useNotifyMessages } from 'api/helpers/useNotifyMessages';
import { CreateAndUpdateOperationParams } from 'api/types/params';

export const useUpdateOperation = () => {
  const [updateOperation, { loading, error: apolloError }] =
    useUpdateOperationMutation();

  const notifyMessage = useNotifyMessages();

  const error = useError(apolloError);

  return {
    updateOperation: useCallback(
      async (
        id: string,
        versionNumber: number,
        params: CreateAndUpdateOperationParams
      ) => {
        const input = parseUpdateOperationParams(params);

        const res = await updateOperation({
          variables: {
            id,
            input: {
              ...input,
              versionNumber,
            },
          },
        });

        if (input && res.data?.updateOperation?.messages) {
          notifyMessage(res.data.updateOperation.messages);
        }

        return res.data?.updateOperation?.data
          ? parseOperationEntity(res.data.updateOperation.data)
          : null;
      },
      [notifyMessage, updateOperation]
    ),
    loading,
    error,
  };
};
